"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _overlay = _interopRequireDefault(require("./overlay"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class PluggableWidget extends _react.default.Component {
  getOptions(plugin) {
    let options = {
      noOverlay: !this.props.editable
    };
    if (typeof plugin.options === 'function') {
      options = Object.assign({}, options, plugin.options(this.props));
    } else if (typeof plugin.options === 'object') {
      options = Object.assign({}, options, plugin.options);
    }
    return options;
  }
  render() {
    const _this$props = this.props,
      block = _this$props.block,
      widget = _this$props.widget,
      extraWidgetProps = _this$props.extraWidgetProps,
      onEdit = _this$props.onEdit,
      onDelete = _this$props.onDelete;
    const plugin = extraWidgetProps.plugins.find(p => p.kind === widget.kind);
    const _this$getOptions = this.getOptions(plugin),
      noOverlay = _this$getOptions.noOverlay;
    const widgetProps = _objectSpread({
      block,
      widget
    }, extraWidgetProps);
    return !noOverlay ? /*#__PURE__*/_react.default.createElement(_overlay.default, {
      onEdit: () => onEdit && onEdit(widget),
      onDelete: () => onDelete && onDelete(widget)
    }, /*#__PURE__*/_react.default.createElement(plugin.component, widgetProps)) : /*#__PURE__*/_react.default.createElement(plugin.component, widgetProps);
  }
}
PluggableWidget.defaultProps = {
  editable: false,
  plugins: []
};
var _default = exports.default = PluggableWidget;